import { render, staticRenderFns } from "./b_table_filter_pager.vue?vue&type=template&id=64b956fd&"
import script from "./b_table_filter_pager.vue?vue&type=script&lang=js&"
export * from "./b_table_filter_pager.vue?vue&type=script&lang=js&"
import style0 from "./b_table_filter_pager.vue?vue&type=style&index=0&id=64b956fd&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b956fd')) {
      api.createRecord('64b956fd', component.options)
    } else {
      api.reload('64b956fd', component.options)
    }
    module.hot.accept("./b_table_filter_pager.vue?vue&type=template&id=64b956fd&", function () {
      api.rerender('64b956fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/b_table_filter_pager.vue"
export default component.exports